import { getOccurences } from "@oefr/utils/string"
import { fetchSbStories } from "../lib/api"

/**
 * Get the list of parent stories with their actual names.
 *
 * @param {string} fullSlug - The current story fullSlug
 */

export const getBreadcrumbStories = async (fullSlug: string) => {
    // We could simply use the resolve_relations="parent_id" but it does not work despite what the Storyblok documentation says
    const trailingSlashlessFullSlug =
        fullSlug[fullSlug.length - 1] === "/" ? fullSlug.slice(0, -1) : fullSlug
    const slugs = trailingSlashlessFullSlug.split("/")
    const slugsToPop = [...slugs]
    slugsToPop.pop() // Current story is already fetched, do not fetch it again

    // For each slug in the fullSlug (rootSlug/slug1/slug2/slug3)
    // We recompose to obtain every slug's fullSlug:
    // - rootSlug
    // - rootSlug/slug1
    // - rootSlug/slug1/slug2
    // - rootSlug/slug1/slug2/slug3
    const recreateLinks = (slugsToPop: string[], links: string[]): string[] => {
        if (slugsToPop.length === 0) {
            return links
        }

        let link: string = ""

        if (slugsToPop.length === 1) {
            link = slugsToPop[0]
        } else {
            slugsToPop.forEach((slug) => {
                link = link ? `${link}/${slug}` : slugsToPop[0]
            })
        }

        links.unshift(link)
        slugsToPop.pop()

        return recreateLinks(slugsToPop, links)
    }
    const links = recreateLinks(slugsToPop, [])
    const stories = await fetchSbStories({ by_slugs: `${links.join("/,")}/` }) // We need to append / to get the actual root folder story

    // Retrieved stories are not in the same order as links
    stories.sort((a, b) => getOccurences(a.full_slug, "/") - getOccurences(b.full_slug, "/"))

    return stories
}
